import { TransactionDetailSectionProps } from '@/components/DataReflection/TransactionDetailSection/types';
import {
  ContentHeader,
  ContentHeaderProps,
} from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/TransactionDetailsDrawer/components/Contents/ContentHeader';
import { DetailList } from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/TransactionDetailsDrawer/components/Contents/DetailList';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import styles from '../../TransactionDetails.module.scss';

type ContentsProps = {
  transactionDetailProps: TransactionDetailSectionProps;
  contentProps?: Partial<ContentHeaderProps>;
  onReselect: () => void;
  isLoadingPulldownOptions?: boolean;
};

const Contents: React.FC<ContentsProps> = ({
  transactionDetailProps,
  contentProps,
  onReselect,
  isLoadingPulldownOptions,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <ContentHeader {...contentProps} />
      <ButtonV2
        containerClassName={styles.btnSelection}
        type='button'
        isTertiary
        onClick={onReselect}
      >
        {t('payment_past_details_reselect')}
      </ButtonV2>
      <DetailList
        {...transactionDetailProps}
        isLoadingPulldownOptions={isLoadingPulldownOptions}
      />
    </>
  );
};

export { Contents };
